import { useFlags } from "launchdarkly-react-client-sdk";

export const useAdminV2Routes = () => {
  const { itemsEnabledForNewAdminUi } = useFlags();

  return itemsEnabledForNewAdminUi || [];
};

export const useHideMicroPaths = () => {
  const { hideMicroPaths } = useFlags();

  return hideMicroPaths;
};

export const useHubspotChat = () => {
  const { hubspotChat } = useFlags();

  return hubspotChat;
};

export const useCsvUploadSvc = () => {
  const { csvUploadService } = useFlags();

  return csvUploadService;
};

export const useEnabledLearnerUiRefreshPages = () => {
  const { enabledLearnerUiRefreshPages } = useFlags();

  return enabledLearnerUiRefreshPages;
};

export const useHideTimeSpent = (): boolean => {
  const { hideTimeSpent } = useFlags();

  return hideTimeSpent ?? false;
};
